import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { getAllCoursesByRole, getAllPayments, getAllUsers, getPaymentsByUserId } from '../../../Constants/Api/functions/function';
import { Button, message, Tabs } from 'antd';

import './styles.scss'

import {
    PlusOutlined,
    DownloadOutlined
} from '@ant-design/icons';
import PaymentsTable from './PaymentsTable';
import AddPayment from './AddPayment';

const Payments = () => {
    const userProfile = useSelector(state => state.userProfile.userProfile);
    const allCources = useSelector(state => state.allCources.allCources);
    const allUsers = useSelector((state) => state.allUsers.allUsers);
    const [users, setUsers] = useState([])
    const [cources, setCources] = useState([])
    const [payments, setPayments] = useState([])
    const [openAddPayment, setOpenAddPayment] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        hadleGetPayments();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (allUsers && allUsers.length) {
            setUsers(allUsers)
        } else {
            handleGetUsers();
        }
    }, [allUsers])

    useEffect(() => {
        if (allCources) {
            if (userProfile?.role === 'coordinator') {
                setCources(allCources.filter(c => (c.coordinatorIds && c.coordinatorIds.includes(userProfile.id)) || (c.coordinatorId && String(c.coordinatorId) === String(userProfile.id))));
            } else if (userProfile?.role === 'instructor') {
                setCources(allCources.filter(c => (c.instructorIds && c.instructorIds.includes(userProfile.id)) || (c.instructorId && String(c.instructorId) === String(userProfile.id))));
            } else {
                setCources(allCources);
            }
        } else {
            handleGetCourses();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allCources, userProfile]);

    const handleGetCourses = async () => {
        setIsLoading(true);
        try {
            const courses = await getAllCoursesByRole(
                userProfile?.role === 'superadmin' || userProfile?.role === 'admin' ? 'superadmin' : userProfile?.role,
                userProfile?.id
            );
            setCources(courses || []);
        } catch (error) {
            console.error('handleGetCourses', error);
        }
        setIsLoading(false);
    }

    const handleGetUsers = async () => {
        setIsLoading(true);
        try {
            const users = await getAllUsers();
            setUsers(users);
        } catch (error) {
            console.error('handleGetUsers', error);
        }
        setIsLoading(false);
    }

    const hadleGetPayments = async () => {
        setIsLoading(true)
        try {
            let paymentsData = [];
            if (userProfile?.role === 'student') {
                paymentsData = await getPaymentsByUserId(userProfile.id);
            } else if (userProfile?.role === 'instructor' || userProfile?.role === 'coordinator') {
                const data = await getAllPayments(userProfile.id, userProfile.role);
                paymentsData = (data || []).filter(p => p.paymentStatus?.toLowerCase() !== 'failed');
            } else {
                paymentsData = await getAllPayments();
            }
            setPayments(paymentsData || []);
        } catch (error) {
            console.error('hadleGetPayments', error);
        }
        setIsLoading(false)
    }

    const handleExportPayments = () => {
        if (!payments || payments.length === 0) {
            message.warning('No payment records to export.');
            return;
        }
        const headers = Object.keys(payments[0]);

        // Custom headers
        headers[0] = 'Payment ID';
        headers[1] = 'User Name';
        headers[2] = 'Course Name';
        headers[3] = 'Amount';
        headers[4] = 'Payment Date';
        headers[5] = 'Payment Method';
        headers[6] = 'Payment Status';

        // Custom data
        payments.forEach((payment) => {
            payment['Payment ID'] = payment.id;
            payment['User Name'] = users.find(user => user.id === payment.userId)?.name;
            payment['Course Name'] = cources.find(course => course.id === payment.courseId)?.name;
            payment['Amount'] = payment.amount;
            payment['Payment Date'] = payment.paymentDate || payment.createdAt;
            payment['Payment Method'] = payment.paymentMethod;
            payment['Payment Status'] = payment.paymentStatus;
        });

        const csvContent =
            "data:text/csv;charset=utf-8," +
            headers.join(",") +
            "\n" +
            payments.map((row) => {
                return headers.map((fieldName) => {
                    return row[fieldName];
                }).join(",");
            }
            ).join("\n");


        const encodedUri = encodeURI(csvContent);
        const link = document.createElement('a');
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "payments.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const isStaff = userProfile?.role === 'superadmin' || userProfile?.role === 'admin' || userProfile?.role === 'coordinator';
    const mainPayments = isStaff 
        ? payments.filter(p => p.paymentStatus !== 'pending')
        : payments;
    const slipPayments = isStaff
        ? payments.filter(p => p.paymentMethod === 'Bank Deposit' && p.paymentStatus === 'pending')
        : [];

    return (
        <div className='payments'>
            <div className='header'>
                <h1>{userProfile?.role === 'student' ? 'My Payment History' : 'Payments'}</h1>
                <div className='actions'>
                    {userProfile?.role !== 'student' && (
                        <>
                            <Button
                                type="default"
                                icon={<DownloadOutlined />}
                                onClick={handleExportPayments}
                            >
                                Export
                            </Button>

                            {(userProfile?.role === 'superadmin' || userProfile?.role === 'admin' || userProfile?.role === 'coordinator') && (
                                <Button
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={() => setOpenAddPayment(true)}
                                >
                                    Add Payment
                                </Button>
                            )}
                        </>
                    )}
                </div>
            </div>

            {isStaff ? (
                <Tabs defaultActiveKey="main" className="payments-tabs">
                    <Tabs.TabPane tab="Payments" key="main">
                        <div className='payments-table'>
                            <PaymentsTable
                                isLoading={isLoading}
                                paymentData={mainPayments}
                                cources={cources}
                                users={users}
                                setPayments={setPayments}
                                role={userProfile?.role}
                                onRefresh={hadleGetPayments}
                            />
                        </div>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={`Slip Uploads (${slipPayments.length})`} key="slips">
                        <div className='payments-table'>
                            <PaymentsTable
                                isLoading={isLoading}
                                paymentData={slipPayments}
                                cources={cources}
                                users={users}
                                setPayments={setPayments}
                                role={userProfile?.role}
                                isSlipTab={true}
                                onRefresh={hadleGetPayments}
                            />
                        </div>
                    </Tabs.TabPane>
                </Tabs>
            ) : (
                <div className='payments-table'>
                    <PaymentsTable
                        isLoading={isLoading}
                        paymentData={payments}
                        cources={cources}
                        users={users}
                        setPayments={setPayments}
                        role={userProfile?.role}
                        onRefresh={hadleGetPayments}
                    />
                </div>
            )}

            {(userProfile?.role === 'superadmin' || userProfile?.role === 'admin' || userProfile?.role === 'coordinator') && (
                <AddPayment
                    isOpen={openAddPayment}
                    setOpen={setOpenAddPayment}
                    hadleGetPayments={hadleGetPayments}
                    users={users}
                />
            )}
        </div>
    )
}

export default Payments